var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94101 6L10.8521 3.08888C11.2094 2.73164 11.2094 2.15244 10.8521 1.79491L10.2052 1.14793C9.84792 0.790696 9.26872 0.790696 8.91119 1.14793L6.00007 4.05906L3.08894 1.14793C2.7317 0.790696 2.1525 0.790696 1.79497 1.14793L1.14799 1.79491C0.790757 2.15215 0.790757 2.73135 1.14799 3.08888L4.05912 6L1.14799 8.91113C0.790757 9.26837 0.790757 9.84757 1.14799 10.2051L1.79497 10.8521C2.15221 11.2093 2.7317 11.2093 3.08894 10.8521L6.00007 7.94095L8.91119 10.8521C9.26843 11.2093 9.84792 11.2093 10.2052 10.8521L10.8521 10.2051C11.2094 9.84786 11.2094 9.26866 10.8521 8.91113L7.94101 6Z",
    fill: "#748CAD"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon.ca346343.svg";
export { ForwardRef as ReactComponent };